import React, { useState } from "react";
import { InfoTip } from "@/components/InfoTip";
import { toast } from "sonner";
import { useL } from "@/lib/useL";

const KEY = "sux1_audience_level";
const OPTIONS = [
  ["aucun", "Tous publics (sans niveau)", "General audience (no level)"],
  ["primaire", "Primaire (CP–CM2)", "Primary school"],
  ["college", "Collège (6ème–3ème)", "Middle school"],
  ["lycee", "Lycée (2nde–Terminale)", "High school"],
  ["superieur", "Supérieur (post-bac)", "Higher education"],
];

// Settings: usual class level, pre-selected on every new summary.
export function DefaultLevel() {
  const L = useL();
  const [value, setValue] = useState(() => { try { return localStorage.getItem(KEY) || "aucun"; } catch { return "aucun"; } });
  const change = (v) => {
    setValue(v);
    try { localStorage.setItem(KEY, v); } catch { /* private mode */ }
    toast.success(L("Niveau de classe habituel enregistré.", "Usual class level saved."));
  };
  return (
    <div className="border border-border p-5 mb-6" data-testid="settings-default-level">
      <div className="sux-marker mb-2 flex items-center gap-1">{L("Niveau de classe habituel", "Usual class level")} <InfoTip testid="settings-default-level-info" content={L("Ex. : vous enseignez en 5e ? Choisissez Collège. Tous vos résumés seront écrits pour des élèves de cet âge.", "E.g. you teach 12-year-olds? Choose Middle school. All your summaries will be written for that age.")} /></div>
      <p className="text-sm text-muted-foreground mb-3">
        {L("Choisi automatiquement pour chaque nouveau résumé, tous formats. Vous pouvez toujours le changer au moment du résumé.",
          "Pre-selected for every new summary, all formats. You can still change it when summarising.")}
      </p>
      <select value={value} onChange={(e) => change(e.target.value)} data-testid="settings-default-level-select"
        className="border border-border bg-background px-3 py-2 text-sm w-full sm:w-auto">
        {OPTIONS.map(([k, fr, en]) => <option key={k} value={k}>{L(fr, en)}</option>)}
      </select>
    </div>
  );
}

export default DefaultLevel;
